const masterServicesStrings = {
  masterServiceDetailsContent: {
    addMasterService: 'Add Master Service',
    editMasterService: 'Edit Master Service',
    confirmButtonLabel: 'Save',
    cancelButtonLabel: 'Cancel',
    arabicNameFieldLabel: 'Arabic Name',
    englishNameFieldLabel: 'English Name',
    statusFieldLabel: 'Status',
    categoryFieldLabel: 'Category',
    formFieldErrorText(fieldName) {
      return `${fieldName} field must have a valid value`;
    },
  },
  masterServicesList: {
    masterServicesGridHeader: {
      masterServicesNameGridHeader: 'Name',
      masterServicesStatusGridHeader: 'Status',
      masterServicesActionsGridHeader: 'Actions',
    },
    masterServicesGridNoResultFound: 'No results matching your search criteria',
  },
  masterServicesFilter: {
    searchBarPlaceholder: 'Search by name',
    statusDropdownPlaceholder: 'Select a status',
  },
  masterServiceDelete: {
    masterServiceDeleteModalTitle: 'Delete Master Service',
    masterServiceDeleteModalConfirmBtn: 'Delete',
    masterServiceDeleteModalConfirmTitle(service) {
      return (
        <p>
          Are you sure you want to delete <b>{service}</b> master service?
        </p>
      );
    },
  },
};

export default masterServicesStrings;
